import { BaseLogger, LogLevel, Logger, VERSION, } from '@doxyme/realtime';
import { setMessageFunc } from '../modules/extensions-framework/sdk';
import { createLogger } from '../utility/datadog-util';
import { PnService } from './pn-service';
const COMMON_CONFIG_SERVICE_NAME = 'realtime';
/**
 * Log level to pass from the Realtime client to the frontend logger.
 * By default it is 'info', which would prevent us processing 'debug' logs.
 */
BaseLogger.setLevel(LogLevel.debug);
/* @ngInject */
export const createPnService = ($rootScope, $log, $ngRedux, env, doxyVersion, growthbookFactory) => {
    const realtimeLogger = createLogger('realtimeLogger', {
        context: {
            package: COMMON_CONFIG_SERVICE_NAME,
            packageVersion: VERSION,
        },
    });
    if (realtimeLogger) {
        let logContext = {};
        const setContextFn = (context) => {
            logContext = context;
        };
        const logFn = (message, logItem, level = LogLevel.debug) => {
            const { date, action, meta } = logItem;
            const attributes = { ...logContext, date, action, meta };
            const prefix = `[Realtime/${action ?? '?'}]`;
            realtimeLogger[level](`${prefix} ${message}`, attributes);
        };
        Logger.override({ log: logFn, setContext: setContextFn });
    }
    const pn = new PnService($log, $rootScope, $ngRedux, doxyVersion, growthbookFactory);
    setMessageFunc(async (uuid, data) => pn.send(uuid, { target: 'extension', data }));
    if (env !== 'production') {
        window['pn'] = pn;
    }
    window.addEventListener('unload', () => {
        void pn.stop(true);
    });
    // beforeunload does not work on ios
    window.addEventListener('beforeunload', () => {
        void pn.stop(true);
    });
    return pn;
};
